import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    droppedUser: {
        id: '',
        roomId: 0,
    },
    receivedInvitationFor: '',
};
const breakoutRoomSlice = createSlice({
    name: 'breakoutRoom',
    initialState,
    reducers: {
        updateBreakoutRoomDroppedUser: (state, action) => {
            state.droppedUser = action.payload;
        },
        updateReceivedInvitationFor: (state, action) => {
            state.receivedInvitationFor = action.payload;
        },
    },
});
export const { updateBreakoutRoomDroppedUser, updateReceivedInvitationFor } = breakoutRoomSlice.actions;
export default breakoutRoomSlice.reducer;
